module.exports = __webpack_public_path__ + "56dd04bbb7904019c2f068100423f73c.png";